export const shortLabel = (t) => (t?.name || "").split(" — ")[0];
